import client from '../session/apiClient';


export function countLocations(groupId = null, accountId = null) {
  return client.get('/v5/locationsCount', { params: { groupId, accountId } }).then(x => x.data);
}
export function getLocations({groupId, accountId, offset, limit, locationId}) {
  return client.get('/v5/locations', { params: { groupId, accountId, offset, limit, locationId } }).then(x => x.data)
}
export function getLocation(locationId, refresh) {
  return client.get('/location/' + locationId).then(response => response.data);
}
export function getLocationsInGroup(groupId) {
  return client.get('/location/group/' + encodeURIComponent(groupId)).then(response => {
    let mappedLocations = {};
    response.data.locations.map(location => mappedLocations[location.locationId] = location);
    return mappedLocations;
  });
}
/**
 *
 * @param locationIds The list of location ids to examine
 * @param propertyName The property to examine
 * @returns a list of distinct values of the property for the specified locations
 */
export function getLocationsProperty({locationIds, propertyName}){
  return client.post('/location/property',
      {
        locationIds: locationIds,
        propertyName: propertyName
      }
  ).then(resp => resp.data)
}

export function getLocationNotificationSettings(groupId) {
  return client.get('/location/' + groupId + '/notificationSettings').then(response => response.data);
}
export function updateNotificationSettings(groupId, notificationUpdates) {
  return client.post(`/location/${groupId}/notificationSettings/update`, {notificationUpdates})
    .then(response => response.data)
}
export function getLocationsForAccount(accountId) {
  return client.get('/location/account/' + encodeURIComponent(accountId))
    .then(response => response.data.locations);
}


export function getLocationsAndGroups({
  locationId,
  includeGroupLocationIds = false,
  search = ""
} = {}) {
  return client.get('/location/search/all', { params: {
    search,
    includeGroupLocationIds: includeGroupLocationIds,
    ...(!!locationId ? {locationId} : {}),
  }})
  .then(response => {
    return response.data;
  });
}

/**
 *
 * @param {string} entityId - prefixed entity id string
 * @return {Promise<LocationGroup|null>}
 */
export function getEntity(entityId) {
  return client.get('/location/locationGroupDetail/' + encodeURIComponent(entityId))
    .then(x => x.data.group || null);
}

/**
 * @typedef {object} PaginationConfig
 * @property {string} [q=""]
 * @property {number} [offset=0]
 * @property {number} [limit=1000]
 */

/**
 *
 * @param {PaginationConfig} [config={}]
 * @return {Promise<{all: LocationGroup[], accounts: LocationGroup[]}>}
 */
export function getAccounts({
  q = "",
  offset = 0,
  limit= 1000,
} = {}) {
  return client.get('/location/search/accounts', { params: {
    q, offset, limit
  }}).then(r => r.data);
}

/**
 * @param {PaginationConfig} [config={}]
 * @return {Promise<{groups: LocationGroup[]}>}
 */
export function getGroups({
  q= "",
  offset = 0,
  limit= 1000,
} = {}) {
  return client.get('/location/search/groups', { params: {
    q, offset, limit
  }}).then(r => r.data);
}

/**
 * @param {PaginationConfig & {locationId?: string}} [config={}]
 * @return {Promise<{locations: LocationGroup[]}>}
 */
export function searchLocations({
  locationId,
  q = "",
  offset = 0,
  limit = 1000,
} = {}) {
  return client.get('/location/search/locations', { params: {
    q,
    ...(!!locationId ? {locationId} : {}),
    limit, offset
  }}).then(r => r.data);
}
